import * as React from 'react';

import clsxm from '@/lib/clsxm';

import { ResponsiveBehavior } from '@/enums/responsive-behavior';

export enum ColWidth {
  FULL = 'FULL',
  MAX_WIDTH_CENTER = 'MAX_WIDTH_CENTER',
  SIDEBAR = 'SIDEBAR',
  COLUMN_WITH_SIDEBAR = 'COLUMN_WITH_SIDEBAR',
  HALF = 'HALF',
  ONE_THIRD = 'ONE_THIRD',
  TWO_THIRDS = 'TWO_THIRDS',
  ONE_FOURTH = 'ONE_FOURTH',
  THREE_FOURTHS = 'THREE_FOURTHS',
  ONE_FIFTH = 'ONE_FIFTH',
}

type Props = {
  children: React.ReactNode;
  colWidth: ColWidth;
  responsiveBehavior?: ResponsiveBehavior;
  className?: string;
};

const colWidthMap: Record<ColWidth, string> = {
  [ColWidth.FULL]: '',
  [ColWidth.MAX_WIDTH_CENTER]: 'container mx-auto sm:w-max',
  [ColWidth.SIDEBAR]: 'w-full md:max-w-[290px] mx-auto mt-16 lg:mt-0',
  [ColWidth.COLUMN_WITH_SIDEBAR]: 'w-full lg:w-[calc(100%-290px)] mx-auto',
  [ColWidth.HALF]: 'lg:w-1/2 lg:max-w-1/2',
  [ColWidth.ONE_THIRD]: 'lg:w-1/3 lg:max-w-1/3 justify-center',
  [ColWidth.TWO_THIRDS]: 'lg:w-2/3 lg:max-w-2/3 flex justify-center',
  [ColWidth.ONE_FOURTH]:
    'md:w-1/2 md:max-w-1/2 lg:w-1/4 lg:max-w-1/4 flex justify-center',
  [ColWidth.THREE_FOURTHS]:
    'md:w-1/2 md:max-w-1/2 lg:w-3/4 lg:max-w-3/4 flex justify-center',
  [ColWidth.ONE_FIFTH]: 'lg:w-1/5 lg:max-w-1/5 flex justify-center',
};

const colWidthResponsiveBehaviorMap: Record<
  ResponsiveBehavior,
  Partial<typeof colWidthMap>
> = {
  [ResponsiveBehavior.SCROLL]: {
    [ColWidth.ONE_THIRD]: 'w-2/3 md:w-2/5',
    [ColWidth.ONE_FOURTH]: 'w-2/3 md:w-2/5',
  },
  [ResponsiveBehavior.STACKED]: {},
};

const Col = ({ className, colWidth, responsiveBehavior, ...rest }: Props) => {
  return (
    <div
      className={clsxm(
        'w-full px-0 pb-1 sm:px-3',
        colWidthMap[colWidth],
        responsiveBehavior &&
          colWidthResponsiveBehaviorMap[responsiveBehavior][colWidth],
        className
      )}
      {...rest}
    />
  );
};
export default Col;
